var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoreInformationNeeded = function SvgMoreInformationNeeded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#moreInformationNeeded_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 100c5.11 0 11.88-2.67 15.19-8.33.205-.32.389-.655.55-1A14.46 14.46 0 0 0 19 85h39v14.187C75.51 92.96 77 68 77 68h10v-9h6l.18 10.15a28.22 28.22 0 0 0 4 14.85c.08.13.15.26.23.38.08.12.26.42.4.62l.29.42c7.44 10.83 20.57 14.58 20.57 14.58H2Z",
    fill: "#C2E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.58 94.3a6.002 6.002 0 0 1 5.986 4.7H120v1H0v-1h3.064c6.061-3.237 11.973-3.237 14.267 0h37.29a7.771 7.771 0 0 1 6.959-4.7ZM25 90v1h-7.41l.45-1H25Zm64-1v1h-8v-1h8Zm8.22-5c.08.13.15.26.23.38.08.12.26.42.4.62H86v-1h11.22Z",
    fill: "#192C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 60.04a4.47 4.47 0 0 1 4.47 4.47v16.64h.04a4.71 4.71 0 0 0 4.71-4.7V66.8a3 3 0 1 1 5.94 0v9.65A10.66 10.66 0 0 1 47.67 87.1V100h-8.94V87.1h-.5c-5.877-.011-10.639-4.773-10.65-10.65v-3.11a3 3 0 0 1 6 0v3.11a4.71 4.71 0 0 0 4.7 4.7h.45V64.51a4.47 4.47 0 0 1 4.47-4.47Z",
    fill: "#116DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 57.37a9.04 9.04 0 1 0 0-18.08 9.04 9.04 0 0 0 0 18.08Z",
    fill: "#FFD527"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "moreInformationNeeded_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgMoreInformationNeeded;